<template>
  <!-- 家庭自然语言干预 -->
  <div class="jiatingziranyuyanganyu">
    <PublicCert :logo="Logo9" :type="'jy-nl'" :color="'#3390cf'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo9 from '@/assets/images/logo9.png'

export default {
  name: 'JiaTingZiRanYuYanGanYu',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo9
    }
  }
}
</script>
